import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../components/ui/tabs';
import { PlayerGamesView } from '../../components/PlayerGamesView';
import { ArrowLeft, User, Activity } from 'lucide-react';
import api from '../../services/api';

const ParentGames = () => {
  const navigate = useNavigate();
  const [players, setPlayers] = useState([]);
  const [activePlayerId, setActivePlayerId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlayers = async () => {
      try {
        const res = await api.get('/players/my-children');
        const list = res.data?.players || res.data || [];
        setPlayers(list);
        if (list.length > 0) setActivePlayerId(list[0].id);
      } catch (e) {
        console.error('Failed to load children', e);
      } finally {
        setLoading(false);
      }
    };
    fetchPlayers();
  }, []);

  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/parent')}
            data-testid="back-to-parent-dashboard"
          >
            <ArrowLeft className="h-4 w-4 mr-1" /> Back
          </Button>
          <div>
            <h1 className="font-heading text-2xl font-bold flex items-center gap-2">
              <Activity className="h-6 w-6 text-blue-600" />
              Games
            </h1>
            <p className="text-sm text-slate-500 mt-1">
              Every tournament game your children have been selected for, RSVP'd to, or rostered on.
            </p>
          </div>
        </div>

        {loading ? (
          <Card>
            <CardContent className="flex items-center justify-center py-10">
              <div className="animate-spin rounded-full h-8 w-8 border-4 border-blue-500 border-t-transparent"></div>
            </CardContent>
          </Card>
        ) : players.length === 0 ? (
          <Card>
            <CardContent className="text-center py-10 text-slate-500">
              <User className="h-12 w-12 mx-auto mb-3 text-slate-300" />
              <p>No children registered yet.</p>
            </CardContent>
          </Card>
        ) : players.length === 1 ? (
          <PlayerGamesView
            playerId={players[0].id}
            title={`${players[0].name || players[0].full_name}'s Games`}
          />
        ) : (
          <Tabs value={activePlayerId || players[0].id} onValueChange={setActivePlayerId}>
            <TabsList className="grid w-full" style={{ gridTemplateColumns: `repeat(${players.length}, 1fr)` }}>
              {players.map((p) => (
                <TabsTrigger key={p.id} value={p.id} data-testid={`parent-games-child-${p.id}`}>
                  {p.name || p.full_name}
                </TabsTrigger>
              ))}
            </TabsList>
            {players.map((p) => (
              <TabsContent key={p.id} value={p.id} className="mt-6">
                <PlayerGamesView playerId={p.id} title={`${p.name || p.full_name}'s Games`} />
              </TabsContent>
            ))}
          </Tabs>
        )}
      </div>
    </DashboardLayout>
  );
};

export default ParentGames;
